module.exports = __webpack_public_path__ + "eedf62b8.png";